import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=34fc65fd&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34fc65fd')) {
      api.createRecord('34fc65fd', component.options)
    } else {
      api.reload('34fc65fd', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=34fc65fd&", function () {
      api.rerender('34fc65fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gcyHCnXoqAH3/JS/offershelp.vue"
export default component.exports